import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const QuarantinedMessageAlert = ({
  shouldRenderPreviewAlert
}) => {
  const title = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "conversations-inbox-message-history.common-message.quarantinedMessage.header"
  });
  if (shouldRenderPreviewAlert) {
    return /*#__PURE__*/_jsx(Alert, {
      type: "danger",
      minBlockSize: "36px",
      children: title
    });
  }
  return /*#__PURE__*/_jsx(Alert, {
    type: "danger",
    titleText: title,
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "conversations-inbox-message-history.common-message.quarantinedMessage.body_jsx",
      options: {},
      elements: {
        UILink: Link
      }
    })
  });
};
QuarantinedMessageAlert.displayName = 'QuarantinedMessageAlert';
export default QuarantinedMessageAlert;